import { useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useResponsesStore } from '@/stores/responses-store'
import { DocumentEditorPage } from '@/components/DocumentEditorPage'
import { FullResponsePage } from '@/components/full-response/FullResponsePage'

/**
 * `/document` is shape-dispatched (spec 29 §8.1): one path, one meaning —
 * "open the response as a document". Single-document artifacts open the
 * editor; multi-section responses open the read-only Full response reader.
 */
export function ResponseDocumentRoute() {
  const { bidId, artifactId } = useParams<{ bidId: string; artifactId: string }>()
  const { selectedArtifact: artifact, fetchArtifactById, error } = useResponsesStore()

  useEffect(() => {
    if (artifactId) void fetchArtifactById(artifactId)
  }, [artifactId, fetchArtifactById])

  if (error && (!artifact || artifact.id !== artifactId)) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-destructive">{error}</div>
    )
  }
  if (!artifact || artifact.id !== artifactId) {
    return (
      <div className="flex h-full items-center justify-center" role="status" aria-label="Loading">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    )
  }
  if (artifact.artifactType === 'excel_schedule') {
    return <Navigate to={`/app/bids/${bidId}/responses/${artifactId}/schedule`} replace />
  }
  if (artifact.artifactType === 'word_form') {
    return <Navigate to={`/app/bids/${bidId}/responses/${artifactId}/form`} replace />
  }
  if (artifact.scopeKind === 'artifact') return <DocumentEditorPage />
  return <FullResponsePage />
}
